import { lazy, Suspense, useEffect } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import Index from "./pages/Index.tsx";
import { initLeadTracking } from "./lib/leadTracking";

const NotFound = lazy(() => import("./pages/NotFound.tsx"));
const Terms = lazy(() => import("./pages/Terms.tsx"));
const Privacy = lazy(() => import("./pages/Privacy.tsx"));
const AdminLogin = lazy(() => import("./pages/AdminLogin.tsx"));
const AdminDashboard = lazy(() => import("./pages/AdminDashboard.tsx"));
const CarlePlace = lazy(() => import("./pages/locations/CarlePlace.tsx"));
const Westbury = lazy(() => import("./pages/locations/Westbury.tsx"));
const Huntington = lazy(() => import("./pages/locations/Huntington.tsx"));
const BayShore = lazy(() => import("./pages/locations/BayShore.tsx"));
const PortJefferson = lazy(() => import("./pages/locations/PortJefferson.tsx"));
const Medford = lazy(() => import("./pages/locations/Medford.tsx"));
const LakeRonkonkoma = lazy(() => import("./pages/locations/LakeRonkonkoma.tsx"));
const NassauCounty = lazy(() => import("./pages/NassauCounty.tsx"));
const SuffolkCounty = lazy(() => import("./pages/SuffolkCounty.tsx"));
const Contractors = lazy(() => import("./pages/industries/Contractors.tsx"));
const HomeServices = lazy(() => import("./pages/industries/HomeServices.tsx"));
const Landscaping = lazy(() => import("./pages/industries/Landscaping.tsx"));
const Restaurants = lazy(() => import("./pages/industries/Restaurants.tsx"));

const queryClient = new QueryClient();

const App = () => {
  useEffect(() => {
    initLeadTracking();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Suspense fallback={<div className="min-h-svh" />}>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/locations/carle-place" element={<CarlePlace />} />
              <Route path="/locations/westbury" element={<Westbury />} />
              <Route path="/locations/huntington" element={<Huntington />} />
              <Route path="/locations/bay-shore" element={<BayShore />} />
              <Route path="/locations/port-jefferson-station" element={<PortJefferson />} />
              <Route path="/locations/medford" element={<Medford />} />
              <Route path="/locations/lake-ronkonkoma" element={<LakeRonkonkoma />} />
              <Route path="/nassau-county" element={<NassauCounty />} />
              <Route path="/suffolk-county" element={<SuffolkCounty />} />
              <Route path="/industries/contractors" element={<Contractors />} />
              <Route path="/industries/home-services" element={<HomeServices />} />
              <Route path="/industries/landscaping" element={<Landscaping />} />
              <Route path="/industries/restaurants" element={<Restaurants />} />
              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;
